import { InvBilling, PsbBilling } from "../BillingComponents";

// Billing Component
export const BillingContent = ({ data }) => {
  const datas = data.currentPeriod
  const fups = data.fups
  const profile = data.profile
  return datas.type ==="psb"
   ? <PsbBilling
        data={datas}
        profile={profile}
        rawData={data}
    />
    : <InvBilling
        data={datas}
        fups={fups}
        profile={profile}
        rawData={data}
    />;
};
